/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ template: NonNullable<unknown>, target: NonNullable<unknown> }} Template_Apply_SuccessInputs */

const en_template_apply_success = /** @type {(inputs: Template_Apply_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The template “${i?.template}” was applied to “${i?.target}”.`)
};

const de_template_apply_success = /** @type {(inputs: Template_Apply_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Vorlage „${i?.template}“ wurde auf „${i?.target}“ angewendet.`)
};

/**
* | output |
* | --- |
* | "The template “{template}” was applied to “{target}”." |
*
* @param {Template_Apply_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_success = /** @type {((inputs: Template_Apply_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_success(inputs)
	return de_template_apply_success(inputs)
});